<section class="zag-selection-summary-panel" role="region" [attr.aria-label]="'bulkEdit.inline.selectionTitle' | translate">
  <header class="zag-selection-summary-panel__header">
    <span zagIcon="checklist" class="zag-selection-summary-panel__header-icon" aria-hidden="true"></span>
    <div class="zag-selection-summary-panel__header-copy">
      <span class="zag-selection-summary-panel__label">
        {{ 'bulkEdit.inline.selectedCount' | translate: { selected: selectedCount(), total: totalCount() } }}
      </span>
    </div>

    <button
      type="button"
      class="zag-selection-summary-panel__select-all"
      [attr.aria-pressed]="allMatchingActive()"
      [zagTooltip]="'bulkEdit.inline.selectAllMatching' | translate"
      (click)="toggleAllMatching()"
    >
      <span [zagIcon]="allMatchingActive() ? 'check-box' : 'check-box-outline-blank'" aria-hidden="true"></span>
      {{ 'bulkEdit.inline.selectAll' | translate }}
    </button>

    <button
      type="button"
      class="zag-selection-summary-panel__cancel"
      [zagTooltip]="'bulkEdit.inline.leaveSelection' | translate"
      (click)="leaveSelection.emit()"
    >
      <span zagIcon="close" aria-hidden="true"></span>
    </button>
  </header>

  <div class="zag-selection-summary-panel__actions">
    @for (section of visibleSections(); track section.id) {
      <button
        zagButton="outlined"
        [zagType]="section.danger ? 'error' : 'primary'"
        type="button"
        class="zag-selection-summary-panel__action"
        [disabled]="selectedCount() === 0"
        (click)="actionSelected.emit(section)"
      >
        <span [zagIcon]="section.icon" aria-hidden="true"></span>
        {{ section.titleKey | translate }}
      </button>
    }
  </div>
</section>
